













































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { QuestionItemForm } from "@/serve/question/question";
import { QuestionGroupForm, QuestionResultForm } from "@/serve/question/questionConfig";

@Component({
  name: "questionGroup"
})
export default class QuestionGroup extends Vue {
  @Prop({ default: false }) public visible!: boolean;
  @Prop({ default: () => [] }) public itemList!: QuestionItemForm[];
  @Prop({ default: () => [] }) public groupList!: QuestionGroupForm[];
  @Prop({ default: false }) public groupLoading!: boolean;
  @Prop({ default: false }) public submitLoading!: boolean;
  @Prop({ default: false }) public groupDialog!: boolean;
  @Prop({ default: "" }) public groupDialogTitle!: string;
  @Prop({ required: true }) public groupForm!: QuestionGroupForm;
  @Prop({ default: () => [] }) public selectedItemIds!: number[];
  @Prop({ default: () => [] }) public groupResultList!: QuestionResultForm[];

  public get innerVisible() {
    return this.visible;
  }

  public set innerVisible(value: boolean) {
    this.$emit("update:visible", value);
  }

  public get innerGroupDialog() {
    return this.groupDialog;
  }

  public set innerGroupDialog(value: boolean) {
    this.$emit("update:groupDialog", value);
  }

  public get innerSelectedItemIds() {
    return this.selectedItemIds;
  }

  public set innerSelectedItemIds(value: number[]) {
    this.$emit("update:selectedItemIds", value);
  }

  public submitGroup() {
    this.$emit("submit-group", this.$refs.groupForm);
  }

  public itemLabel(item: QuestionItemForm) {
    return `${item.itemCode || ""} ${item.itemTitle || ""}`.trim();
  }

  public groupTypeLabel(value: string) {
    const map: { [key: string]: string } = { total: "全部", part: "部分" };
    return map[value] || value || "";
  }

  public scoreMethodLabel(value: string) {
    const map: { [key: string]: string } = { sum: "求和", max: "最高分", min: "最低分" };
    return map[value] || value || "";
  }

  private groupRules = {
    groupCode: [{ required: true, message: "请输入分组编码", trigger: "blur" }],
    groupName: [{ required: true, message: "请输入分组名称", trigger: "blur" }],
    groupType: [{ required: true, message: "请选择分组类型", trigger: "change" }]
  };
}
